import { createApi } from '@reduxjs/toolkit/query/react';
import { dataQuery } from '../config/query.config';
import { cookieService } from '@lib/cookie.service';
import {
  ITotalFansResponse,
  ITotalFansPayload,
  ITotalClaimedBadgesResponse,
  ITotalClaimedBadgesPayload,
  IHistoricClaimResponse,
  IHistoricClaimPayload,
  ITotalCollabPayload,
  ITotalCollabResponse,
  IHistoricClaimsPayload,
  IHistoricClaimsResponse,
} from './types';
import { TimezoneService } from '@ui/lib';

export const metricsApi = createApi({
  reducerPath: 'metricsApi',
  baseQuery: dataQuery,
  endpoints: (builder) => ({
    getFans: builder.query<ITotalFansResponse, ITotalFansPayload>({
      query: ({ initialDate, finalDate }) => {
        const creatorId = cookieService.getUserId();
        const localtime = TimezoneService.getFormattedLocalTime();
        return {
          url: `/public/v1/total_new_fans_by_creator/${creatorId}?initial_date=2020-01-01&final_date=2060-01-01&trend=false`,
          params: {
            localtime,
          },
        };
      },
    }),
    getHistoricFan: builder.query<ITotalFansResponse, ITotalFansPayload>({
      query: ({ initialDate, finalDate }) => {
        const creatorId = cookieService.getUserId();
        const localtime = TimezoneService.getFormattedLocalTime();
        const trend = true;
        return {
          url: `/public/v1/total_new_fans_by_creator/${creatorId}?initial_date=${initialDate}&final_date=${finalDate}&trend=${trend}&granularity=DAILY`,
          params: { localtime },
        };
      },
    }),
    getNewFans: builder.query<ITotalFansResponse, ITotalFansPayload>({
      query: ({ initialDate, finalDate }) => {
        const creatorId = cookieService.getUserId();
        const localtime = TimezoneService.getFormattedLocalTime();
        return {
          url: `/public/v1/total_new_fans_by_creator/${creatorId}?initial_date=${initialDate}&final_date=${finalDate}`,
          params: { localtime },
        };
      },
    }),
    getTotalBadgeClaims: builder.query<ITotalClaimedBadgesResponse, ITotalClaimedBadgesPayload>({
      query: ({ initialDate, finalDate }) => {
        const creatorId = cookieService.getUserId();
        const localtime = TimezoneService.getFormattedLocalTime();
        return {
          url: `/public/v1/total_collectibles_by_source/${creatorId}?initial_date=${initialDate}&final_date=${finalDate}`,
          params: {
            localtime,
          },
        };
      },
    }),
    getHistoricBadgeClaims: builder.query<IHistoricClaimResponse, IHistoricClaimPayload>({
      query: ({ initialDate, finalDate }) => {
        const creatorId = cookieService.getUserId();
        const localtime = TimezoneService.getFormattedLocalTime();
        return {
          url: `/public/v1/historic_claims_by_creator/${creatorId}?initial_date=${initialDate}&final_date=${finalDate}&granularity=DAILY`,
          params: {
            localtime,
          },
        };
      },
    }),
    getHistoricCollabClaims: builder.query<IHistoricClaimResponse, IHistoricClaimPayload>({
      query: ({ initialDate, finalDate }) => {
        const creatorId = cookieService.getUserId();
        const localtime = TimezoneService.getFormattedLocalTime();
        return {
          url: `/public/v1/historic_collaborated_claims_by_creator/${creatorId}?initial_date=${initialDate}&final_date=${finalDate}&granularity=DAILY`,
          params: {
            localtime,
          },
        };
      },
    }),
    getTotalCollaborationBadges: builder.query<ITotalCollabResponse, ITotalCollabPayload>({
      query: ({ initialDate, finalDate }) => {
        const creatorId = cookieService.getUserId();
        const localtime = TimezoneService.getFormattedLocalTime();

        return {
          url: `/public/v1/collaborated_collectibles_by_user/${creatorId}?initial_date=${initialDate}&final_date=${finalDate}`,
          params: { localtime },
        };
      },
    }),
    // Badge historic
    getHistoricClaimedBadge: builder.query<IHistoricClaimsResponse, IHistoricClaimsPayload>({
      query: ({ badgeId, initialDate, finalDate }) => {
        const creatorId = cookieService.getUserId();
        const localtime = TimezoneService.getFormattedLocalTime();

        return {
          url: `/public/v1/historic_claims_by_badge/${badgeId}?initial_date=${initialDate}&final_date=${finalDate}&granularity=DAILY`,
          method: 'POST',
          body: {
            badges: [badgeId],
          },
          params: { localtime },
        };
      },
    }),
  }),
});

export const {
  useGetFansQuery,
  useGetNewFansQuery,
  useGetTotalBadgeClaimsQuery,
  useGetHistoricBadgeClaimsQuery,
  useGetHistoricCollabClaimsQuery,
  useGetTotalCollaborationBadgesQuery,
  useGetHistoricClaimedBadgeQuery,
  useGetHistoricFanQuery,
} = metricsApi;
